var components
try {
  components = {
    uButton: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-button/u-button" */ "uview-ui/components/u-button/u-button.vue"
      )
    },
    uModal: function () {
      return import(
        /* webpackChunkName: "node-modules/uview-ui/components/u-modal/u-modal" */ "uview-ui/components/u-modal/u-modal.vue"
      )
    },
  }
} catch (e) {
  if (
    e.message.indexOf("Cannot find module") !== -1 &&
    e.message.indexOf(".vue") !== -1
  ) {
    console.error(e.message)
    console.error("1. 排查组件名称拼写是否正确")
    console.error(
      "2. 排查组件是否符合 easycom 规范，文档：https://uniapp.dcloud.net.cn/collocation/pages?id=easycom"
    )
    console.error(
      "3. 若组件不符合 easycom 规范，需手动引入，并在 components 中注册该组件"
    )
  } else {
    throw e
  }
}
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var m0 = _vm.info ? _vm.returnStyle(_vm.info.status) : null
  var m1 = _vm.info ? _vm.returnStyle1(_vm.info.status) : null
  var g0 = _vm.info ? [2, 1, 0, 5, 8].includes(_vm.info.status) : null
  if (!_vm._isMounted) {
    _vm.e0 = function ($event) {
      _vm.show2 = true
    }
  }
  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        m0: m0,
        m1: m1,
        g0: g0,
      },
    }
  )
}
var recyclableRender = false
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns, recyclableRender, components }